import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import "./MultiSelectInput.css";

export const MultiSelectInput = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
}) => {
  return (
    <div className="multiSelectInputWrapper">
      {label && <label className="multiSelectLabel" htmlFor={name}>{label}</label>}
      <div className="multiSelectWrapper">
        <FormControl fullWidth error={!!error}>
          <Select
            id={name}
            multiple
            value={value}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty
            className="multiSelectInput"
            renderValue={(selected) =>
              selected.length === 0
                ? <span className="placeholder">Selecione pelo menos uma opção</span>
                : options
                    .filter((opt) => selected.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(', ')
            }
          >
            <MenuItem disabled value="">
              <em>Selecione pelo menos uma opção</em>
            </MenuItem>
            {options.map((option) => (
              <MenuItem className="multiSelectOption" key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {error && <p className="textError">{error}</p>}
        </FormControl>
      </div>
    </div>
  );
};
